export default __webpack_public_path__ + "static/media/avatar.8769c6d0.png";